import React from "react";
/**
 * The member as a circle: the picture when there is one (or a freshly chosen one, as "preview"),
 * otherwise the initials, as in the top bar.
 */
export const ProfileAvatar = ({ image, preview, initials, large }) => {
    const className = `bi-pf-avatar${large ? " bi-pf-avatar-lg" : ""}`;
    const src = preview !== null && preview !== void 0 ? preview : ((image === null || image === void 0 ? void 0 : image.hasImage) ? image.url : undefined);
    return src
        ? React.createElement("img", { className: className, src: src, alt: "" })
        : React.createElement("span", { className: className, "aria-hidden": "true" }, initials);
};
